module.exports = {
      id: "icon-diaverum-logo-usage",
      viewBox: "0 0 40 48",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-diaverum-logo",
      toString: function () {
        return this.url;
      }
    }